<template>

  <v-dialog v-model="dialog" scrollable width="800px">
    <v-card>

      <v-card color="#004884" flat dark>
        <v-card-text class="font-weight-light text-xs-left title underlineheadline">
          {{cardTitle}}
        </v-card-text>
      </v-card>
      <v-card-text>
        <v-layout row wrap justify-start>
          <v-flex>
            <v-card flat>
              <v-card-title>
                {{description}}
              </v-card-title>
            </v-card>
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click="dialog=false" color="#004884" small dark outline class="radiusBtn text-none"> {{'BUTT_OK' | translate}}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import Vue from 'vue'

  export default {
    name: 'DialogLoginFailed',
    components: {},
    methods: {
      /**
       * newName, title, type
       * @param cardConfig
       */
      open: function (cardConfig) {
        if ((cardConfig != null) && (cardConfig)) {
          this.newName = cardConfig.newName
          this.cardTitle = cardConfig.title
          this.type = cardConfig.type
          this.description = cardConfig.description
        }
        this.dialog = true
      }
    },
    data () {
      return {
        cardTitle: '',
        type: 'group',
        pwOld: '',
        pwNew: '',
        pwNew2: '',
        imageLayout: '0',
        questionTyp: '1',
        mySubjects: {},
        description: '',
        dialog: false
      }
    },
    mounted () {

    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/dialogs/DialogLoginFailed.vue